const LOGIN_KEY = "resly-login-key";
const PLATFORM_KEY = "resly-platform-key";
const PROJECT_KEY = "resly-project-key";
const BLOCK_SAVE_KEY = "resly-block-save-key";
const CONFIG_SAVE_KEY = "resly-config-key";

const getProjectId = () => {
    return sessionStorage.getItem(PROJECT_KEY);
};
const setProjectId = (PK) => {
    if (PK == true) {
        console.trace("Setting project ID to:", PK);
    }
    if (PK === null) {
        sessionStorage.removeItem(PROJECT_KEY);
    } else {
        sessionStorage.setItem(PROJECT_KEY, PK);
    }
};

const getLoginFlag = () => {
    return sessionStorage.getItem(LOGIN_KEY);
};

const setLoginFlag = (flag) => {
    if (flag === null) {
        sessionStorage.removeItem(LOGIN_KEY);
    } else {
        sessionStorage.setItem(LOGIN_KEY, flag);
    }
};

const getPlatform = () => {
    return sessionStorage.getItem(PLATFORM_KEY);
};

const setPlatform = (platformName) => {
    if (platformName === null) {
        sessionStorage.removeItem(PLATFORM_KEY);
    } else {
        sessionStorage.setItem(PLATFORM_KEY, platformName);
    }
};

const getSavedXmlBlocks = () => {
    return localStorage.getItem(BLOCK_SAVE_KEY);
};

const setSavedXmlBlocks = (xmlContent) => {
    if (xmlContent === null) {
        localStorage.removeItem(BLOCK_SAVE_KEY);
    } else {
        localStorage.setItem(BLOCK_SAVE_KEY, xmlContent);
    }
};

const getReslyConfig = () => {
    const configString = localStorage.getItem(CONFIG_SAVE_KEY);
    return configString ? JSON.parse(configString) : null;
};

const setReslyConfig = (newConfig) => {
    if (newConfig === null) {
        localStorage.removeItem(CONFIG_SAVE_KEY);
    } else {
        localStorage.setItem(CONFIG_SAVE_KEY, JSON.stringify(newConfig));
    }
};

const TokenService = {
    // Project
    getProjectId,
    setProjectId,

    // Platform
    getPlatform,
    setPlatform,

    // Local Blocks
    getSavedXmlBlocks,
    setSavedXmlBlocks,

    // Config
    getReslyConfig,
    setReslyConfig,

    // Login
    getLoginFlag,
    setLoginFlag,
};

export default TokenService;
